<template>
  <img
      :src="overlay.imageUrl"
      :style="{
      position: 'absolute',
      width:overlay.width,
        left: overlay.position.x + 'px',
      top: overlay.position.y + 'px',
       border: isSelected ? '2px solid blue' : 'none'
    }"
      :class="{ 'overlay-image': isDragging }"
  

      @contextmenu.prevent="handleContextMenu"
  />
</template>

<script>
export default {
  props: {
    overlay: { imageUrl: '', width:'150px', producto:'', position: { x: 0, y: 0 }, id:0},
    backgroundImageSize: Object,
    overlayIndex: null
  },
  data() {
    return {
      isDragging: false,
      isSelected: false,
        flagclick:false,
      initialPosition: { x: 0, y: 0 },
      currentPosition: { x: this.overlay.position.x, y: this.overlay.position.y },
      model: this.overlay.id

    };
  },
  methods: {
    clickDragging(event){
      if(this.flagclick){
        this.flagclick = false
        this.stopDragging()
      }else{
        this.flagclick = true
        this.startDragging(event)
      }
      this.$emit("contextproduct", this.model);
    },
    handleContextMenu(event) {
      event.preventDefault();
      // Emitir evento personalizado para indicar al padre que se hizo clic derecho
      this.$emit("overlay-contextmenu", this.overlayIndex);
    },
    startDragging(event) {
      this.isSelected = true;
      this.isDragging = true;
      console.log('START')
      console.log(event)
      this.initialPosition = {
        x: event.clientX - this.currentPosition.x,
        y: event.clientY - this.currentPosition.y
      };
    },
    drag(event) {
      if (this.isDragging) {
        console.log('MOVIENDO')
        const newX = event.clientX - this.initialPosition.x;
        const newY = event.clientY - this.initialPosition.y;
        this.currentPosition = {
          x: newX,
          y: newY
        };
        this.$emit('overlay-moved', this.overlayIndex, this.currentPosition);

      }
    },
    stopDragging() {
      console.log('no lee el isdragging')
      if (this.isDragging) {
        console.log('TERMINO')
        this.isSelected = false;
        this.isDragging = false;
        console.log(this.currentPosition)
        this.$emit('overlay-moved', this.overlayIndex, this.currentPosition);
      }
    }
  }
};
</script>
<style scoped>
/* ... otros estilos ... */
.overlay-image {
  cursor: move;
}
</style>